import { AuditLiveMention } from '@app/modules/audit/modules/station-audit/types';
import { toDateTimeStr } from '@mi-front/core';
import { defineMessage } from 'react-intl';
import { useMentionDateScheduleOriginal } from './useMentionDateScheduleOriginal';
import { VerifyMatchTextSection } from './VerifyMatchTextSection';

const mentionContentTitleMessage = defineMessage({
  id: 'audit.verifyMatch.mentionContentTitle',
  defaultMessage: 'Contenido de la mención',
});

const noMentionContentMessage = defineMessage({
  id: 'audit.verifyMatch.noMentionContent',
  defaultMessage: 'No hay contenido de mención disponible para esta detección.',
});

export interface VerifyMatchMentionContentProps {
  mention: AuditLiveMention;
  stationId: string;
  timezone: string;
  open: boolean;
}

/**
 * Shows the programmed mention script (`original`) from the date schedule,
 * falling back to the mention match `description` when original is unavailable.
 */
export function VerifyMatchMentionContent({
  mention,
  stationId,
  timezone,
  open,
}: VerifyMatchMentionContentProps) {
  const {
    data: original,
    isLoading,
    isError,
  } = useMentionDateScheduleOriginal(
    stationId,
    timezone,
    mention.name,
    toDateTimeStr(mention.datetime),
    open,
  );

  // Prefer date-schedule original; only fall back to description after the query settles.
  const content = original || (!isLoading ? mention.description?.trim() || null : null);

  return (
    <VerifyMatchTextSection
      title={mentionContentTitleMessage}
      emptyMessage={noMentionContentMessage}
      content={content}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
